import React, { useEffect, useState } from 'react'
import '../flight-search/banner-carousel.css'
import imgs from '../../../assets/images/default-banner.webp'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Container } from 'react-bootstrap'
import { ADMIN_IMAGE, API_BASE_URL } from '../../../utility/apiConstants'
import { getAuth } from '../../../utility/apiConfig'
const Banner = () => {
  const [textArray, setTextArray] = useState([]);
  const [bannerArray, setBannerArray] = useState(null)
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 15000,
    focusOnSelect: true,
    fade: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const defaultBanners = [
    {id: 1, img: imgs, className: 'img-banner', alt: 'Slider-img'},
  ]

  useEffect(() => {
    getTextSlider();
    getBanners();
  }, [])

  const getTextSlider = () => {
    try {
      getAuth(API_BASE_URL + 'data/text_slider')
        .then((response) => {
          if (response.data.status) {
            setTextArray(response.data.data && response.data.data.data_list.length > 0 ? response.data.data.data_list : [])
          }
        })
        .catch((err) => {

        })
    } catch (error) {

    }
  }

  const getBanners = () => {
    try {
      getAuth(API_BASE_URL + 'data/main_banner')
        .then((response) => {
          if (response.data.status && response.data !== null) {
            setBannerArray(response.data);
          }
        })
        .catch((err) => {
          setBannerArray(defaultBanners);
        })
    } catch (error) {
      setBannerArray(defaultBanners);
    }
  }
  
  return (
        <Container fluid className="img-content">
            {
                textArray.length > 0
                  ? <marquee className="marquee" behavior="scroll" direction="left" scrollamount="7">
            {
                textArray.map((item, index) => {
                  return (<span key={index} className="pr-5">{item.content}</span>)
                })
            }
            </marquee>
                  : null }
    {(bannerArray !== null && bannerArray.status === true && bannerArray.data && bannerArray.data.length > 0 )?
            (<Slider {...settings}>
              {bannerArray.data.map((item) => 
              <div>
              {/* <img src={imgs} className="img-banner" alt="Slider-img" /> */}
     <div className={'banner-bg-image'} style={{
      // backgroundImage: "url(" + img1 + ")",
      backgroundImage: "url(" + `${ADMIN_IMAGE}/banner/${item.image}.webp` + ")",

       
     }}>
       <div className={'container'}>
          <div className='banner-text'>
            <h3 className={'banner-'+item.image}>{item.title}</h3>
            <h4 className={'banner-des-'+item.image}>{item.subtitle}</h4>
          </div>
       </div>

       {/* <h3 className={'banner-14'}>{item.title}</h3>
       <h4 className={'banner-des-14'}>{item.subtitle}</h4> */}

     </div>
   </div>)}
   </Slider>)
              :
              (<Slider {...settings}>
              {defaultBanners.map((item) => 
               <div>
                   <img src={item.img} className={item.className} alt={item.alt} />
                </div>
              )}
            </Slider>)}
        </Container>
  )
}
export default Banner
